import { PAGE_NAMES } from "../../../../components/H5ChristmasIndexPage/h5-config";
import { getQueryParam } from "../../../utils";
export const SET_USER_IMAGE = 'SET_USER_IMAGE';
export const SET_CUR_PAGE = 'SET_CUR_PAGE';
export const SET_VIDEO_EXTRA = 'SET_VIDEO_EXTRA';
export const SET_MATERIAL_IMAGE = 'SET_MATERIAL_IMAGE';
export const setUserImage = (userImage) => ({
    type: SET_USER_IMAGE,
    payload: {
        userImage
    }
});
export const setCurPage = (pageName) => {
    return {
        type: SET_CUR_PAGE,
        payload: {
            pageName
        }
    };
};
export const setVideoExtra = (videoExtra) => {
    return {
        type: SET_VIDEO_EXTRA,
        payload: {
            videoExtra
        }
    };
};
export const setMaterialImage = (materialImage) => {
    return {
        type: SET_MATERIAL_IMAGE,
        payload: {
            materialImage,
        }
    };
};
const initialState = {
    userImage: '',
    curPage: !!getQueryParam('video') ? PAGE_NAMES.GUEST : PAGE_NAMES.INDEX,
    videoExtra: {},
    materialImage: '', // AB测试拉到的素材信息
};
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_USER_IMAGE: {
            const { userImage } = action.payload;
            console.log('state change, userImage: ');
            return Object.assign(Object.assign({}, state), { userImage });
        }
        case SET_CUR_PAGE: {
            const { pageName } = action.payload;
            console.log('state change, pageName: ', pageName);
            return Object.assign(Object.assign({}, state), { curPage: pageName });
        }
        case SET_VIDEO_EXTRA: {
            const { videoExtra } = action.payload;
            console.log('state change, videoExtra: ', videoExtra);
            return Object.assign(Object.assign({}, state), { videoExtra });
        }
        case SET_MATERIAL_IMAGE: {
            const { materialImage } = action.payload;
            console.log('state change, materialImage: ', materialImage);
            return Object.assign(Object.assign({}, state), { materialImage });
        }
        default:
            return state;
    }
}
